const mainColor = "#111111";
const secondaryColor = "#222222";

const cardBG = "#222222";

export { mainColor, secondaryColor, cardBG };
